import React, { useEffect } from "react";
import { enableMXForIDF, ezsServiceIds } from "../../config/UserServicesList";
import { useAreServicesActive } from "../../util/CommonServices";

function Iframe(props: any) {
    return <div dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />;
}
interface IProps {
    src: string;
    title:string;
    closeDialog: any;
    dialogId: string;
}
const AddAccountDialog: React.FunctionComponent<IProps> = (props) => {
    const mxServiceList = [ezsServiceIds.financialTransactionMonitoringMX];
    const ismxServiceActive = useAreServicesActive(mxServiceList) || enableMXForIDF;

    const src = props.src;
    const yodleePopup = {
        source: ismxServiceActive
            ? '<iframe id="myIframe" title="Connect Your Account" width="100%" height="166" scrolling="yes" frameborder="no" src=' +
              src +
              ' style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;"></iframe>'
            : '<iframe id="myIframe" title="Connect Your Account" width="100%" height="166" scrolling="no" frameborder="no" src=' +
              src +
              ' style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;"></iframe>',
    };
    const RefreshAndClose = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };
    useEffect(() => {
        document.querySelector<any>(`[aria-labelledby=${props.dialogId}-title]`)!.classList.add("width-xl");
    }, []);
    useEffect(() => {
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                RefreshAndClose();
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            <div className="dialog-header">
                <h1>{props.title}</h1>
            </div>

            <div className="dialog-body">
                <Iframe iframe={yodleePopup["source"]} />
            </div>

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => RefreshAndClose()}>
                            <span className="btn-text">Cancel</span>
                        </button>
                    </div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={RefreshAndClose}>
                            <span className="btn-text">Done</span>
                        </button>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default AddAccountDialog;
